import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../models/Login";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface ITargetHistory {
    user_Name?: string,
    team_Name?: string,
    login_ID?: number | null,
    sub?: null,
    req?: number | null,
    ecs?: number | null,
    eci?: number | null,
    po?: number | null,
    yesterday_Total_Req?: number | null,
    yesterday_Total_ECI?: number | null,
    yesterday_Total_ECS?: number | null,
    period_Total_Req?: number,
    period_Total_ECI?: number,
    period_Total_ECS?: number,
    period_Total_PO?: number,
}

export const SaleTargetReport = (permissions: IPermissionProps) => {
    const [subTableData, setSubTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITargetHistory>, loading: boolean });
    const [openAlertBox, setOpenAlertBox] = useState(false)
    const [openRecBox, setOpenRecBox] = useState(false)
    const [tableData1, setTableData1] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [runalert, setAlert] = useState(false)
    const [lastPODate, setLastPODate] = useState<string | undefined>();
    const [lastPOAgp, setLastPOAgo] = useState<string | undefined>();
    const hasMounted = useRef(false);

    //const [filters, setFilters] = useState<IFilterTarget>(EmptyFilter);
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    // const today = new Date();
    // const previousDate = new Date(today);
    // let day = previousDate.getDate() - 1;
    // let month = previousDate.getMonth() + 1;
    // let year = previousDate.getFullYear();
    // if (day === 0) {
    //     let previousMonthLastDay = new Date(previousDate.getFullYear(), previousDate.getMonth(), 0);
    //     day = previousMonthLastDay.getDate();
    //     month = previousMonthLastDay.getMonth() + 1;
    //     year = previousMonthLastDay.getFullYear();
    // }
    // const formattedDate = `${day}/${month}/${year}`;

    const DateFormat = loginObj.date_Format;
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    const formattedDate = safeFormatDate(
        yesterday.toISOString(),
        "dd/MM/yyyy",
        DateFormat
    );
    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Target Report</h5>
        </div>
    );


    const header1 = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <p style={{ fontWeight: 'bold' }}>
                <span style={{ color: 'red' }}>
                    Hi
                </span>
                <span style={{ color: 'blue' }}>
                    ! {JSON.parse(sessionStorage.getItem('auth') + "")?.name}
                </span>
                <span style={{ color: 'red' }}>
                    , Our records show your last PO was on [{lastPODate}] which was [{lastPOAgp} days Ago]. If you’re expecting POs, consider checking with your client. We're here to help if needed.
                </span>
            </p>
        </div>
    );

    const loadSalesRecruitersData = async (endPoint: string) => {
        setSubTableData({ tableData: subTableData.tableData, loading: true });

        const response = await Fetch(`Tbl_Targets/${endPoint}`, "GET", null, null, toast);
        if (response) {
            const data: Array<ITargetHistory> = await response.json();
            setSubTableData({ tableData: data, loading: false });
        } else setSubTableData({ tableData: subTableData.tableData, loading: false });
    };

    useEffect(() => {
        if (_roles.includes(2)) loadSalesRecruitersData("reportIndiSales");
        if (_roles.includes(3) || _roles.includes(21)) loadSalesRecruitersData("reportIndiRecruiter");
    }, []);

    const getLastPOPoData = async () => {
        const response = await Fetch("Dashboard/LastPODate", "GET", null, null, null);
        const data = await response?.json();
        if (data[0].daysAgo > 15) {
            setLastPODate(data[0].pO_Date)
            const formattedDate = data[0].pO_Date
                ? format(new Date(data[0].pO_Date), 'dd/MM/yyyy').toUpperCase()
                : "";
            setLastPODate(formattedDate);
            setLastPOAgo(data[0].daysAgo)
            setAlert(true);
        } else {
            setAlert(false);
        }
    }

    useEffect(() => {
        if (!hasMounted.current) {
            // First run (page reload) — skip API calls
            hasMounted.current = true;
            return;
        }
        getLastPOPoData();
        if (_roles.includes(2) && runalert) {
            loadTableData();
            setOpenAlertBox(true)
        } else if ((_roles.includes(3) || _roles.includes(21)) && runalert) {
            loadTableData1();
            setOpenRecBox(true)
        }
    }, [runalert]);


    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Dashboard/Lastpodetails", "GET", null, null, null);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }


    const loadTableData1 = async () => {
        setTableData1({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Dashboard/RecruitersDetails", "GET", null, null, null);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData1({ tableData: data, loading: false });
        }
    }



    useEffect(() => {
        // const isReload = performance.navigation.type === 1 || performance.navigation.type === 2;

        // if (isReload) {
        //     // Prevent running on reload
        //     return;
        // }

        const interval = setInterval(() => {
            getLastPOPoData();
            if (_roles.includes(2) && runalert) {
                loadTableData();
                setOpenAlertBox(true)
            } else if ((_roles.includes(3) || _roles.includes(21)) && runalert) {
                loadTableData1();
                setOpenRecBox(true)
            }
        }, 1000 * 60 * 60); // every 60 minute
        return () => clearInterval(interval);
    }, [runalert]);

    return (
        <>
            {(_roles.includes(2) || _roles.includes(3) || _roles.includes(4) || _roles.includes(5) || _roles.includes(21)) && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginBottom: "10px", zIndex: 0 }}
                ref={dt} size="small" stripedRows showGridlines scrollable resizableColumns scrollHeight="30vh"
                emptyMessage=" "
                value={subTableData.tableData}
                loading={subTableData.loading}
            >
                {(_roles.includes(2) || _roles.includes(5)) && <Column field="req" header="Req Target" headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-cyan-300" />}
                {(_roles.includes(2) || _roles.includes(5)) && <Column field="yesterday_Total_Req" header={`${formattedDate}`} headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-green-400" />}
                {(_roles.includes(2) || _roles.includes(5)) && <Column field="period_Total_Req" header="Total Req" headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-yellow-400" />}

                {(_roles.includes(3) || _roles.includes(21) || _roles.includes(4)) && <Column field="sub" header="Sub Target" headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-cyan-300" />}
                {(_roles.includes(3) || _roles.includes(21) || _roles.includes(4)) && <Column field="yesterday_Total_SUB" header={`${formattedDate}`} headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-green-400" />}
                {(_roles.includes(3) || _roles.includes(21) || _roles.includes(4)) && <Column field="period_Total_SUB" header="Total Sub" headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-yellow-400" />}

                <Column field="ecs" header="ECS" headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-cyan-300" />
                <Column field="yesterday_Total_ECS" header={`${formattedDate}`} headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-green-400" />
                <Column field="period_Total_ECS" header="Total ECS" headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-yellow-400" />

                <Column field="eci" header="ECI" headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-cyan-300" />
                <Column field="yesterday_Total_ECI" header={` ${formattedDate}`} headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-green-400" />
                <Column field="period_Total_ECI" header="Total ECI" headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-yellow-400" />

                <Column field="po" header="PO" headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-cyan-300" />
                <Column field="period_Total_PO" header="Total PO" headerStyle={{ fontWeight: "bolder", fontSize: "22px" }} bodyStyle={{ fontWeight: "bolder" }} className="bg-yellow-400" />

            </DataTable>}

            <Dialog visible={openAlertBox} style={{ width: '50vw' }} header={header1} modal className="p-fluid" onHide={() => { setOpenAlertBox(false); }}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    resizableColumns columnResizeMode="expand"
                    scrollable scrollHeight="30vh"
                    value={tableData.tableData}
                    emptyMessage="No Requirements found."

                    loading={tableData.loading}
                >
                    <Column field="noOfReq" header="#Req" sortable />
                    <Column field="noOfSub" header="#Sub" />
                    <Column field="noOfSubClient" header="#ECS" />
                    <Column field="noOfECI" header="#ECI" />
                    <Column field="po" header="PO" />
                </DataTable>
            </Dialog>
            <Dialog visible={openRecBox} style={{ width: '50vw' }} header={header1} modal className="p-fluid" onHide={() => { setOpenRecBox(false); }}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    resizableColumns columnResizeMode="expand"
                    scrollable scrollHeight="30vh"
                    value={tableData1.tableData}
                    emptyMessage="No Requirements found."
                    loading={tableData1.loading}
                >
                    <Column field="noOfAllReq" header="#Req" sortable />
                    <Column field="noOfSub" header="#Sub" />
                    <Column field="noOfSubClient" header="#ECS" />
                    <Column field="noOfECI" header="#ECI" />
                    <Column field="po" header="#PO" />
                </DataTable>
            </Dialog>
        </>
    );
}
